// src/App.js
import React, { Suspense, useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { restoreSession } from './store/slices/authSlice';
import LoadingSpinner from './components/LoadingSpinner';
import ErrorBoundary from './components/ErrorBoundary';
import routesConfig from './routes/routesConfig';
import { Toaster } from './components/ui/toast';
import { useTokenRefresh } from './hooks/useTokenRefresh';
import useAuthSync from './hooks/useAuthSync';

const App = () => {
  const routes = useRoutes(routesConfig);
  const dispatch = useDispatch();

  // Cross-tab auth synchronization - syncs login/logout across browser tabs
  useAuthSync({ requestSessionOnMount: true });

  // Proactive token refresh - handles automatic token renewal
  useTokenRefresh({ enabled: true, maxRetries: 3 });

  // Restore session on app load
  useEffect(() => {
    dispatch(restoreSession());
  }, [dispatch]);

  return (
    <ErrorBoundary
      showDetails={process.env.NODE_ENV === 'development'}
      maxRetries={3}
    >
      <Suspense fallback={<LoadingSpinner />}>
        {routes}
      </Suspense>
      <Toaster position="top-right" closeButton />
    </ErrorBoundary>
  );
};

export default App;